// extracted by mini-css-extract-plugin
module.exports = {"parent":"Parent_parent__pFY9p","hide":"Parent_hide__2ED2X"};